module.exports = __webpack_public_path__ + "mo/img/process_3.1b88c8db.png";